import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Stack,
  TextField,
  Autocomplete,
} from "@mui/material";
import { updateUser } from "../../api";
import { countryStates } from "../../config/constant";

const userDetails = JSON.parse(sessionStorage.getItem("userInfo")) || {};

let filterVal;

if (userDetails) {
  const { license, status, name, ...restVal } = userDetails;
  filterVal = restVal;
}

export const AccountProfileDetails = (props) => {
  const [values, setValues] = useState(() => {
    try {
      const userDetails = JSON.parse(sessionStorage.getItem("userInfo"));
      const { license, status, name, ...restVal } = userDetails;
      return restVal;
    } catch (error) {
      return undefined;
    }
  });

  const [flag, setFlag] = useState(false);

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const onSubmit = async () => {
    const json = {
      userid: userDetails?.userid,
      apikey: userDetails?.apikey,
      user_info: values,
    };

    const res = await updateUser(json);
    if (res?.errcode === 0) {
      sessionStorage.setItem(
        "userDetails",
        JSON.stringify({ ...userDetails, ...values })
      );

      setFlag(true);

      props?.refresh();
    }
    
    setTimeout(() => {
      setFlag(false);
    }, 2000);
    clearTimeout();
  };

  return (
    <Card sx={{ height: "100%" }}>
      <form autoComplete="off" noValidate {...props}>
        <CardHeader subheader="The information can be edited" title="Profile" />
        <Divider />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                helperText="Please specify the first name"
                label="First name"
                name="first_name"
                onChange={handleChange}
                required
                value={values?.first_name}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Last name"
                name="last_name"
                onChange={handleChange}
                required
                value={values?.last_name}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Email Address"
                name="email"
                onChange={handleChange}
                required
                value={values?.email}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Phone Number"
                name="phone"
                onChange={handleChange}
                type="number"
                value={values?.phone}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <Autocomplete
                options={countryStates.map((option) => option.name)}
                fullWidth
                renderInput={(params) => (
                  <TextField {...params} label="Country" />
                )}
                name="country"
                onChange={(e, value) =>
                  handleChange({
                    target: {
                      name: "country",
                      value,
                    },
                  })
                }
                required
                value={values?.country}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <Autocomplete
                fullWidth
                options={(() => {
                  try {
                    if (!values.country) return [];
                    return countryStates
                      .find((option) => option.name === values.country)
                      .states.map((option) => option.name);
                  } catch (error) {
                    return [];
                  }
                })()}
                renderInput={(params) => (
                  <TextField {...params} label="State" />
                )}
                name="state"
                onChange={(e, value) =>
                  handleChange({
                    target: {
                      name: "state",
                      value,
                    },
                  })
                }
                required
                value={values?.state}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 2,
          }}
        >
          <Button color="primary" variant="contained" onClick={onSubmit}>
            Save details
          </Button>
        </Box>
        
        {flag && (
          <>
            <Stack sx={{ width: "40%", margin: "10px" }} spacing={2}>
              <Alert severity="success">Update Is Successful</Alert>
            </Stack>
          </>
        )}
      </form>
    </Card>
  );
};
